import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import colorPaletteOutline from '../images/color-palette-outline.svg';
import colorPaletteGreyOutline from '../images/color-palette-grey.svg'
import blurimg from '../images/blur.svg'
import dotsimg from '../images/dots.svg'
import dotssquareimg from '../images/dots-square.svg'
import pattern from '../images/pattern-services.svg'
import HowWeDoSection from '../page-sections/how-we-do-section';

function Services() {
    const currentYear = new Date().getFullYear();
    return (
        <>


            <div id="home">
                <div className="cover-img position-relative h-40vh" style={{ background: 'rgba(233, 182, 59,1)' }} >
                    {/*, */}

                    {/* Design */}
                    <div className="d-flex pattern-img" style={{ backgroundImage: `url(${pattern})` }}>

                    </div>


                    <div className="overlays glass">
                        {/* h-41rem */}
                        <Container fluid className="py-5">
                            <Row className="h-100 mt-3">
                                <Col md={10} className="mx-auto">
                                    <Row className="h-100">
                                        <Col md={12} lg={12} className="d-flex">
                                            <div className="text-white mt-5">
                                                {/* <span className="text-uppercase fs12  sub-title">We are Veeyaa Innovatives</span> */}
                                                <h1 className='page-title mt-4 yellow'>Services <br /> We Provide</h1>





                                                {/* <button className="btn btn-cards br-20px  px-4">Contact Us</button> */}
                                            </div>
                                        </Col>

                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </div>


            {/* Floating icons */}
            {/* <span className="fas fa-times floating-icon color-purple roate-alternative" style={{ top: '15%', right: '60px', fontSize: '60px' }}></span>
            <span className="fas fa-circle floating-icon  color-green beat-infinet" style={{ bottom: '120px', left: '25px', fontSize: '30px' }} ></span>
            <span className="far fa-square floating-icon  color-blue roate-infinet" style={{ top: '45%', left: '80px', fontSize: '20px' }}></span>

            <span className="fas fa-play floating-icon  color-yellow roate-infinet" style={{ fontSize: '60px', left: '30px', top: '5%' }}></span>

            <span className="fas fa-circle-notch floating-icon  color-red fs120 roate-infinet" style={{ bottom: '23%', right: '-50px' }}></span>



            <img src={dotssquareimg} alt="floating-icons" className="floating-icon position-absolute" style={{ width: '100px', left: '-5px', bottom: '50px' }} />
            <img src={blurimg} alt="floating-icons" className="floating-icon position-absolute" style={{ width: '160px', left: '-7px', top: '330px' }} />

            <img src={dotsimg} alt="floating-icons" className="floating-icon position-absolute" style={{ width: '160px', right: '-17px', bottom: '30px' }} />
 */}



            <Container className="my-5">
                <div className=" mb-5">

                    <Row>
                        <Col xl={3} md={4} className="smallerdesign">

                            <ul className="d-flex about-us-design flex-nowrap justify-content-center row-1 mb-0">
                                <li>
                                    <span className="lnr lnr-history"></span>
                                    <div className="fs18 mt-4 heading">On Time</div>
                                </li>
                                {/* <li>
                                    <span className="lnr lnr-smile"></span>
                                    <div className="fs18 mt-4 heading">User Friendly</div>
                                </li> */}
                            </ul>
                            {/* <ul className="d-flex about-us-design justify-content-center flex-nowrap row-2">
                                <li>
                                    <span>₹</span>
                                    <div className="fs18 mt-4 heading">Best in Market</div>
                                </li>
                                <li>
                                    <img src={colorPaletteOutline} alt="color-pallet" />
                                    <div className="fs18 mt-4 heading">Customizable</div>
                                </li>
                            </ul> */}
                        </Col>
                        <Col xl={9} md={8} className="pt-5  mt-lg-0 pl-4">
                            <div className='service-card purple mt-5'>

                                <h2 className="text-left">
                                    Web Development
                                </h2>
                                <p className="text-left">
                                    Create powerful, responsive websites that engage your audience and drive results.
                                </p>


                                <div className="d-flex align-items-center my-4 pt-3">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Custom Website Development</h2>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">E-commerce Solutions</h2>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Content Management Systems</h2>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Web Application Development</h2>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Website Maintenance & Support</h2>
                                    </div>
                                </div>



                            </div>


                        </Col>
                    </Row>


                    <Row>

                        <Col xl={9} md={9} className="mx-xl-auto mt-lg-0 order-2 order-md-1">
                            <div className='service-card yellow mt-5'>

                                <h2 className="text-left">
                                   Mobile App Development
                                </h2>
                                <p className="text-left">
                                    Native and cross-platform mobile applications that deliver exceptional user experience across all devices.
                                </p>


                                <div className="d-flex align-items-center my-4 pt-3">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Custom Website Development</h2>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">iOS App Development</h2>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Android App Development</h2>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Cross-Platform Solutions</h2>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">App UI/UX Design</h2>
                                    </div>
                                </div>

                                 <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">App Maintenance & Updates</h2>
                                    </div>
                                </div>



                            </div>


                        </Col>
                        <Col xl={3} md={3} className="smallerdesign  order-1 order-md-2">

                            <ul className="d-flex about-us-design justify-content-center flex-nowrap row-2 mt-5 pl-0">
                                <li className="d-none"></li>
                                <li className="pl-0">
                                      <span className="lnr lnr-laptop-phone"></span>
                                    <div className="fs18 mt-4 heading text-center">Mobile App <br /> Development</div>
                                </li> 
                            </ul>
                        </Col>
                    </Row>

                    <Row>
                        <Col xl={3} md={4} className="smallerdesign">

                            <ul className="d-flex about-us-design justify-content-center flex-nowrap row-2 mt-5 pl-0">
                                <li className="pl-0">
                                    <span className="lnr lnr-phone-handset"></span>
                                    <div className="fs18 mt-4 heading">IT Consulting</div>
                                </li>
                            </ul>
                        </Col>

                        <Col xl={9} md={8} className="mx-xl-auto mt-lg-0">
                            <div className='service-card blue mt-5'>

                                <h2 className="text-left">
                                   IT Consulting
                                </h2>
                                <p className="text-left">
                                  Strategic technology consulting to help you make informed decisions and achieve your business goals.
                                </p>


                                <div className="d-flex align-items-center my-4 pt-3">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Digital Strategy Development</h2>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Technology Assessment</h2>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Process Optimization</h2>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">IT Infrastructure Planning</h2>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Digital Transformation</h2>
                                    </div>
                                </div>



                            </div>


                        </Col>

                    </Row>

                     <Row>

                        <Col xl={9} md={8} className="mx-auto mt-lg-0 order-2 order-md-1">
                            <div className='service-card orange mt-5'>

                                <h2 className="text-left">
                                    Web Hosting & Maintenance
                                </h2>
                                <p className="text-left">
                                   Reliable Web Hosting and Maintenance ensures an intermittent online presence for the deployed software.
                                </p>


                                <div className="d-flex align-items-center my-4 pt-3">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Cost-Effective</h2>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Own Your Space in Our Server</h2>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Regular Backups (the Safety Net)</h2>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Rented Hosting Server</h2>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center my-4">
                                    <div className="circle-count">
                                        <span className="lnr lnr-checkmark-circle"></span>
                                    </div>
                                    <div className="text-left ml-3">
                                        <h2 className="fs16 mb-1">Performance and Speed Optimization</h2>
                                    </div>
                                </div>



                            </div>


                        </Col>
                        <Col xl={3} md={4} className="smallerdesign  order-1 order-md-2">

                            <ul className="d-flex about-us-design justify-content-center flex-nowrap row-1 mt-5 pl-0">
                                <li className="d-none"></li>
                                 <li>
                                    <span className="lnr lnr-earth"></span>
                                    <div className="fs18 mt-4 heading text-center">Web Hosting  and<br/> Maintenance</div>
                                </li>
                            </ul>
                        </Col>
                    </Row>

                </div>
            </Container>

        </ >
    );
}

export default Services;
